import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { resources, DEFAULT_LOCALE, dirFor } from '@/lib/i18n';

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: DEFAULT_LOCALE,
    supportedLngs: ['en', 'ar'],
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'venue.locale',
      caches: ['localStorage'],
    },
  });

/** §25 — direction is a document-level concern, applied once on every change. */
function applyDirection(lng: string) {
  document.documentElement.lang = lng;
  document.documentElement.dir = dirFor(lng);
}

applyDirection(i18n.language || DEFAULT_LOCALE);
i18n.on('languageChanged', applyDirection);

export default i18n;
